import { render, staticRenderFns } from "./ProductosUpdate.vue?vue&type=template&id=6309229c&"
import script from "./ProductosUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductosUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports